import { render, staticRenderFns } from "./SelectUploadTypeDialog.vue?vue&type=template&id=56b2da20&"
import script from "./SelectUploadTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SelectUploadTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports